<template>
    <div class="row">
        <div class="col-12" v-if="isInitialized">
            <tabs ref="tab-grants" type="info" @activate-tab="activateTab" square>
                <tab-pane :id="'grants_' + grant.grantId" :label="grant.description" v-for="grant in grants" v-bind:key="grant.grantId">
                    <div class="row d-flex">
                        <div class="col-lg-3" v-for="(application) in applications" :key="application.application_id">
                            <card>
                                <template slot="header">
                                    <h3 class="card-title">{{ grant.description }}</h3>
                                    <h4 class="card-title">{{ application.reference }}</h4>
                                </template>
                                <div>
                                    <router-link :to="{ name: 'Edit Monitoring', params: { grantId: application.grant_id, applicationId: application.application_id }}">
                                        <base-button type="primary" size="lg" simple>VIEW</base-button>
                                    </router-link>
                                </div>
                            </card>
                        </div>
                    </div>
                </tab-pane>
            </tabs>
        </div>
    </div>
</template>
<script>
    import {MonitoringService, GrantService} from '@/services';
    import {TabPane, Tabs} from 'src/components';
    import {Select, Option} from 'element-ui';

    export default
    {
        components:
        {
            TabPane,
            Tabs,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data()
        {
            return {
                isInitialized: false,
                grants: [],
                applications: [],
                currentGrantId: 0,
            }
        },
        async beforeCreate()
        {
            const vm = this;
            const loader = vm.$loading.show();

            await GrantService.all().then((response) =>
            {
                vm.grants = response.data;

                if (vm.currentGrantId === 0)
                {
                    vm.currentGrantId = vm.grants[0].grantId;
                }
            });

            await vm.getApplications();

            vm.isInitialized = true;

            loader.hide();
        },
        methods:
        {
            async getApplications()
            {
                const vm = this;
                const loader = vm.$loading.show();
                const response = await MonitoringService.getAwardedApplications(
                {
                    grant_id: vm.currentGrantId
                });

                if (response)
                {
                    vm.applications = response.data;
                }

                loader.hide();
            },
            activateTab(ev)
            {
                const vm = this;

                vm.currentGrantId = +ev.id.replace('grants_', '');

                vm.getApplications();
            },
        },
    };
</script>
<style lang="scss">
    .filters-holder
    {
        position: absolute;
        right: 0;
        z-index: 10;
    }
</style>
